import React from 'react'

import { DefaultPopover } from 'twyne-new.ui';

import useBubbleMenuPosition from './hooks';

export default function Wrapper({ children, size, editor }) {
  const { visible, position, toolbarRef, interactingRef, update } = useBubbleMenuPosition({ editor })

  const layoutClasses = `flex align-center ${size === 'small' ? 'flex-col' : 'flex-row'}`

  if (!visible || !position) return null

  return <DefaultPopover
    trigger={<div
      className='pointer-events-none fixed z-50 h-50 w-50'
      style={{
        left: (position.left + position.right) / 2,
        top: position.top - 5,
        opacity: 0,
      }}
    />}
    triggerProps={{ asChild: true }}
    wrapperProps={{ open: visible, onOpenChange: () => { } }}
    contentProps={{
      side: 'top',
      align: 'center',
      sideOffset: 2,
      collisionPadding: 12,
      className: `border-gray-300 border rounded-xs shadow-md p-1 pointer-events-auto w-max! max-w-[calc(100vw-24px)] bg-white! text-gray-800!`,
      onOpenAutoFocus: event => event.preventDefault(),
    }}
  >
    <div
      ref={toolbarRef}
      onMouseEnter={() => interactingRef.current = true}
      onMouseLeave={() => {
        interactingRef.current = false
        requestAnimationFrame(update)
      }}
      onMouseDown={() => {
        interactingRef.current = true
        requestAnimationFrame(update)
      }}
      className={`${layoutClasses} whitespace-nowrap`}
    >
      {children}
    </div>
  </DefaultPopover>
}
